import * as Sentry from '@sentry/browser';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import PageCrash from './page-crash';

export default class ErrorBoundary extends Component {
  static propTypes = {
    children: PropTypes.element.isRequired,
  };

  state = {
    error: false,
  };

  componentDidCatch(error, info) {
    Sentry.withScope((scope) => {
      scope.setExtras(info);
      Sentry.captureException(error);
      this.setState({ error: true });
    });
  }

  render() {
    const { children } = this.props;
    const { error } = this.state;
    if (error) {
      return <PageCrash />;
    }
    return children;
  }
}
